// @flow
import * as React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import Icons from 'ui/Icons'

import Button from './Button'

type Props = {
  text: string,
  onCopy?: () => void,
  showCopied?: boolean,
}

function CopyButton({ text, onCopy, showCopied }: Props): React.Node {
  const [showCopiedState, setShowCopiedState] = React.useState(false)

  return (
    <CopyToClipboard
      onCopy={() => {
        setShowCopiedState(true)
        if (onCopy) {
          onCopy()
        }
      }}
      text={text}
    >
      <Button $plain className="pr-2 ml-2 relative">
        {showCopiedState ? (
          <Icons.CheckCircle color="text-green-500" />
        ) : (
          <Icons.Clipboard color="text-gray-700" />
        )}
      </Button>
    </CopyToClipboard>
  )
}

export default CopyButton
